<div class="cart-totals-list-item">
  <span class="label text-b3-s-500 text-md-b4-l-500">{{ label() }}</span>
  <span class="dots"></span>
  <span class="value text-b3-s-700 text-md-b4-l-700">{{ value() }}</span>
</div>
